import apiClient from 'commons/api/client/apiClient';
import store from 'commons/store/Store';

type NewsletterData = { customer: boolean; partner: boolean };

async function getNewsletterData() {
  const { data } = await apiClient.request({
    method: 'GET',
    url: `/user-core/users/${store.state.user.data.id}/newsletter`,
  });
  return data as NewsletterData;
}

async function updateNewsletterData(newsletterData: NewsletterData) {
  const { data } = await apiClient.request({
    method: 'PUT',
    url: `/user-core/users/${store.state.user.data.id}/newsletter`,
    data: newsletterData,
  });
  return data;
}
async function getPaymentInfo() {
  const { data } = await apiClient.request({
    method: 'GET',
    url: `/user-core/users/${store.state.user.data.id}/payment-info`,
  });
  return data;
}
async function updatePaymentInfo(paymentInfoData) {
  const { data } = await apiClient.request({
    method: 'PUT',
    url: `/user-core/users/${store.state.user.data.id}/payment-info`,
    data: paymentInfoData,
  });
  return data;
}
async function getTaxationData() {
  const { data } = await apiClient.request({
    method: 'GET',
    url: `/user-core/users/${store.state.user.data.id}/taxation`,
  });
  return data;
}
async function updateTaxationData(taxationData) {
  const { data } = await apiClient.request({
    method: 'POST',
    url: `/user-core/users/${store.state.user.data.id}/taxation`,
    data: taxationData,
  });
  return data;
}
async function getTrolleyIFrame() {
  const { data } = await apiClient.request({
    method: 'POST',
    url: `/trolley/${store.state.user.data.id}/iframe-url`,
  });

  if (!data?.url) {
    return Promise.reject();
  }

  return data?.url;
}
async function getTrolleyStatus() {
  const { data } = await apiClient.request({
    method: 'GET',
    url: `/trolley/${store.state.user.data.id}/status`,
  });
  return data;
}
async function sendTrolleyEvent({ module, event }) {
  const { data } = await apiClient.request({
    method: 'GET',
    url: `/trolley/${store.state.user.data.id}/modules/${module}/events/${event}`,
  });
  return data;
}

type AdressData = {
  company?: string | null;
  street: string | null;
  streetAnnex: string | null;
  zipCode: string | null;
  city: string | null;
  state: string | null;
  country: {
    code: string | null;
    value: string | null;
  };
  person: {
    salutation: string | null;
    firstName: string | null;
    lastName: string | null;
  };
};

async function getAddressData() {
  try {
    const { data } = await apiClient.request({
      method: 'GET',
      url: `/user-core/users/${store.state.user.data.id}/address`,
    });
    return data as AdressData;
  } catch (error) {
    if (error.status === 404) {
      return {
        ...error.data,
        company: undefined,
      };
    }

    throw Error(error);
  }
}
async function updateAddressData(addressData: AdressData) {
  const { data } = await apiClient.request({
    method: 'POST',
    url: `/user-core/users/${store.state.user.data.id}/address`,
    data: {
      ...addressData,
      originalStreet: addressData.street, // temporary fix until backend removed originalStreet field and is allowing updated via street, remove when DEV-217458 is released
    },
  });
  return data;
}

type CountryData = {
  countryCode: string;
  name: string;
  isEu: boolean;
  states: { code: string; value: string }[];
};

async function getCountries() {
  const { data } = await apiClient.request({
    method: 'GET',
    url: `/user-core/users/countries`,
  });
  return data.countries as CountryData[];
}

export default {
  getNewsletterData,
  updateNewsletterData,
  getPaymentInfo,
  updatePaymentInfo,
  getTaxationData,
  updateTaxationData,
  getTrolleyIFrame,
  getTrolleyStatus,
  sendTrolleyEvent,
  getAddressData,
  updateAddressData,
  getCountries,
};

export type { NewsletterData, AdressData, CountryData };
